export default __webpack_public_path__ + "media/src/features/home-page-redesign/assets/dashboardIcon-1d84a22b42b71d78d669f0972bf38b60.svg";